<script setup lang="ts">
import { ChevronUp } from "@lucide/vue";
import { SelectScrollUpButton, type SelectScrollUpButtonProps } from "radix-vue";

const props = defineProps<SelectScrollUpButtonProps>();
</script>

<template>
	<SelectScrollUpButton
		v-bind="props"
		:class="['flex cursor-default items-center justify-center py-1', $attrs.class]"
	>
		<slot>
			<ChevronUp class="size-4" />
		</slot>
	</SelectScrollUpButton>
</template>
